<template>
    <div class="main-content">
        <div class="uk-padding">
            <ul class="uk-breadcrumb">
                <li><router-link to="/projects">Projecten</router-link></li>
            </ul>
            <h1 class="uk-align-left">Projecten</h1>
            <div class="uk-align-right">
                <a href="#page-modal" uk-toggle uk-icon="icon: plus; ratio: 2"></a>
            </div>
            
            <table class="uk-table">
                <thead>
                    <tr>
                        <th width="30"></th>
                        <th>Naam</th>
                        <th>Categorie</th>
                        <th>Laatste update</th>
                        <th width="30"></th>
                        <th width="30"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(p, id) in projects">
                        <td><span uk-icon="icon: bolt; ratio: 1.2"></span></td>
                        <td>{{p.name}}</td>
                        <td v-if="p.category">{{p.category}}</td>
                        <td v-else-if="p.categories"><span v-for="c in p.categories">{{c}} - </span></td>
                        <td>{{convertDate(p.lastEdit)}}</td>
                        <td>
                            <router-link :to="{ name: 'ProjectEdit', params: { id: id }}" class="uk-link" uk-icon="icon: cog"></router-link>
                        </td>
                        <td>
                            <a class="uk-link" @click.prevent="remove(id)" uk-icon="icon: trash"></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div id="page-modal" uk-modal>
            <div class="uk-modal-dialog">
                <button class="uk-modal-close-default" type="button" uk-close></button>
                <div class="uk-modal-header">
                    <h2 class="uk-modal-title">Project maken</h2>
                </div>
                <div class="uk-modal-body">
                    <form>
                        <fieldset class="uk-fieldset">
                            <div class="uk-margin">
                                <input class="uk-input" v-model="newProject.name" type="text" placeholder="Projectnaam">
                            </div>
                            <div class="uk-margin">
                                <input class="uk-input" v-model="newProject.title" type="text" placeholder="Titel">
                            </div>
                            <div class="uk-margin">
                                <Vueditor ref="editor"></Vueditor>
                            </div>
                            <div class="uk-margin">
                                <input class="uk-input" v-model="newProject.link.url" type="text" placeholder="Link">
                            </div>
                            <div class="uk-margin">
                                <input class="uk-input" v-model="newProject.link.text" type="text" placeholder="Link Text">
                            </div>
                            <div class="uk-margin">
                                <input class="uk-input" v-model="newProject.color" type="text" placeholder="Project Kleur (hex)">
                            </div>
                             <div class="uk-margin">
                                <select class="uk-select uk-form-width-medium" v-model="newCategory">
                                    <option :value="key" v-for="(c, key) in categories">{{c}}</option>
                                </select>
                                <button @click.prevent="addCategory" class="uk-button uk-button-secondary">toevoegen</button>
                            </div>
                            <div class="uk-margin" v-if="Object.keys(this.newProject.categories).length > 0">
                                <div class="uk-column-span" v-for="(c, key) in this.newProject.categories">
                                    <p class="uk-align-left">{{c}}</p>
                                    <button class="uk-align-right uk-label uk-label-danger" @click.prevent="removeCategory(key)"><span uk-icon="trash"></span></button>
                                </div>
                                
                            </div>
                            <image-picker @choose="choose"></image-picker>
                            <div class="uk-margin">
                                <vue-image :img="newProject.gallery"/>  
                            </div>
                        </fieldset>
                    </form>
                </div>
                <div class="uk-modal-footer">
                    <div class="uk-align-right">
                        <button class="uk-button uk-button-primary uk-align-right uk-modal-close" type="submit" @click.prevent="add">Toevoegen</button>
                        <button class="uk-button uk-button-danger uk-align-right uk-modal-close" @click="cancel">Annuleren</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
var moment = require('moment');
import {db} from '@/CUSTOM/helpers/firebase'
import imagePicker from '@/CORE/modules/MEDIA/imagePicker'
import VueImage from '@/CORE/modules/MEDIA/VueImage'
import Vue from 'vue';
export default {
    name: 'Projects',
    components: {imagePicker, VueImage},
    data () {
        return {
            projects: null,
            categories: null,
            newCategory: null,
            newProject: {
                name: null,
                titel: null,
                info: null,
                link: {
                    url: null,
                    text: null,
                },
                color: null,
                categories: {},
                gallery: []
            }
        }
    },
    created () {
        db.collection('projects').onSnapshot((snap) => {
            this.projects = {}
            snap.forEach((doc) => {
                this.projects[doc.id] = doc.data()
            })
        })
        db.collection('categories').doc('all').get().then(doc => {
            this.categories = doc.data()
        }).catch(error => {
            console.log(error)
        })
    },
    methods: {
        add () {
            this.newProject.created = Math.floor(Date.now() / 1000)
            this.newProject.lastEdit = Math.floor(Date.now() / 1000)
            this.newProject.info = this.$refs.editor.getContent();
            //TODO: CHECK IF PROJECT NAME ALREADY EXSISTS
            db.collection('projects').doc(this.newProject.name.toLowerCase().split(' ').join('-')).set(this.newProject)
        },
        cancel () {
            this.newProject = {
                name: null,
                titel: null,
                info: null,
                link: {
                    url: null,
                    text: null,
                },
                color: null,
                categories: {},
                gallery: []
            }
        },
        addCategory () {
            Vue.set(this.newProject.categories, this.newCategory, this.categories[this.newCategory])
        },
        removeCategory (key) {
            Vue.delete(this.newProject.categories, key)
        },
        convertDate (timestamp) {
            return moment.unix(timestamp).fromNow();
        },
        choose (images) {
            for(var i in images) {
                var img = images[i]
                this.newProject.gallery.push({key: i, description: img.description, url: img.url, extralarge: img.extralarge, medium: img.medium, large: img.large, small: img.small, cover: false, placeholder: img.placeholder, alt: img.alt, title: img.title})
            }
            setTimeout(() => {
                UIkit.modal("#page-modal").show();
            }, 200);
        }, 
        remove (id) {
            UIkit.modal.confirm('Ben je zeker dat je dit project wil verwijderen?').then(() => {
               return db.collection('projects').doc(id).delete().then(() => {
                   UIkit.notification({message: 'Project Verwijderd', status: 'danger'})
               })
           });
        }
    }
}
</script>


// WEBPACK FOOTER //
// Projects.vue?511a429b